/**
 * Shadow configuration based on the existing CSS custom properties
 * @param {boolean} darkMode - Whether to use dark mode
 * @returns {string[]} MUI shadows array
 */
export const shadows = (darkMode = false) => {
  const shadowColor = darkMode ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.1)';
  const shadowColorDarker = darkMode ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.2)';
  
  return [
    'none',
    `0 1px 2px 0 ${shadowColor}`,
    `0 1px 3px 0 ${shadowColor}, 0 1px 2px -1px ${shadowColor}`,
    `0 2px 4px -1px ${shadowColor}, 0 1px 2px -1px ${shadowColor}`,
    `0 4px 6px -1px ${shadowColor}, 0 2px 4px -2px ${shadowColor}`,
    `0 6px 8px -2px ${shadowColor}, 0 3px 5px -2px ${shadowColor}`,
    `0 8px 10px -3px ${shadowColor}, 0 4px 6px -3px ${shadowColor}`,
    `0 10px 12px -3px ${shadowColor}, 0 5px 8px -3px ${shadowColor}`,
    `0 12px 14px -4px ${shadowColor}, 0 6px 10px -4px ${shadowColor}`,
    `0 14px 16px -4px ${shadowColor}, 0 8px 12px -4px ${shadowColor}`,
    `0 16px 18px -5px ${shadowColor}, 0 10px 14px -5px ${shadowColor}`,
    `0 18px 20px -5px ${shadowColor}, 0 12px 16px -5px ${shadowColor}`,
    `0 20px 22px -6px ${shadowColor}, 0 14px 18px -6px ${shadowColor}`,
    `0 22px 24px -6px ${shadowColor}, 0 16px 20px -6px ${shadowColor}`,
    `0 24px 26px -7px ${shadowColor}, 0 18px 22px -7px ${shadowColor}`,
    `0 26px 28px -7px ${shadowColor}, 0 20px 24px -7px ${shadowColor}`,
    `0 28px 30px -8px ${shadowColor}, 0 22px 26px -8px ${shadowColor}`,
    `0 30px 32px -8px ${shadowColor}, 0 24px 28px -8px ${shadowColor}`,
    `0 32px 34px -9px ${shadowColor}, 0 26px 30px -9px ${shadowColor}`,
    `0 34px 36px -9px ${shadowColor}, 0 28px 32px -9px ${shadowColor}`,
    `0 36px 38px -10px ${shadowColor}, 0 30px 34px -10px ${shadowColor}`,
    `0 38px 40px -10px ${shadowColor}, 0 32px 36px -10px ${shadowColor}`,
    `0 40px 42px -11px ${shadowColor}, 0 34px 38px -11px ${shadowColor}`,
    `0 42px 44px -11px ${shadowColor}, 0 36px 40px -11px ${shadowColor}`,
    `0 44px 46px -12px ${shadowColorDarker}, 0 38px 42px -12px ${shadowColorDarker}`,
  ];
};